import * as ToggleDoubleSeats from './toggle-double-seats/ui/ToggleDoubleSeats/ToggleDoubleSeats.css';
import * as ShowRecommendedSeats from './show-recommended-seats/ui/ShowRecommendedSeats/ShowRecommendedSeats.css';
import * as Attention from './attention/ui/Attention/Attention.css';
import * as SeatsFilter from './seats-filter/ui/SeatsFilter/SeatsFilter.css';
import * as ConfirmRecommendationsButton from './confirm-recommendations/ui/ConfirmRecommendationsButton/ConfirmRecommendationsButton.css';
import * as CancelRecommendationsButton from './cancel-recommendations/ui/CancelRecommendationsButton/CancelRecommendationsButton.css';
import * as SeatsLegendModal from './show-legend-modal/ui/SeatsLegendModal/SeatsLegendModal.css';
import * as SeatsLegendModalButton from './show-legend-modal/ui/SeatsLegendModalButton/SeatsLegendModalButton.css';
import * as SuggestionModal from './suggestion-modal/ui/SuggestionModal/SuggestionModal.css';

export default {
	ToggleDoubleSeats,
	ShowRecommendedSeats,
	Attention,
	SeatsFilter,
	ConfirmRecommendationsButton,
	CancelRecommendationsButton,
	SeatsLegendModal,
	SeatsLegendModalButton,
	SuggestionModal
};
